var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && !_vm.isLoadingOrder)?_c('div',{staticClass:"section-summary"},[(_vm.isVip())?[_c('div',{staticClass:"vip-confirm-container"},[_c('div',{staticClass:"vip-confirm-image"},[_c('img',{staticClass:"image",attrs:{"src":_vm.resizeImage(_vm.data?.product_main?.image_url, 640),"alt":"product image"}})]),_c('div',{staticClass:"vip-confirm-product-name"},[_vm._v(" "+_vm._s(_vm.data.product_main.name || 'ไม่พบข้อมูล')+" ")])])]:[_c('CheckoutProductItems',{staticClass:"mb-4",attrs:{"isDefault":false,"data":[
        {
          imageUrl: _vm.data.product_main.image_url,
          name: _vm.data.product_main.name,
          price_ship: _vm.data.product_main.price,
        },
        ..._vm.bundles,
      ]}}),_c('CheckoutSummary',{attrs:{"isDefault":false,"cartSummaryData":_vm.cartSummaryData,"isDeposit":_vm.isDeposit,"isPickupAtStore":!_vm.isDelivery,"shipDate":_vm.shippingDate}})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }